import React from 'react'
import { useEffect, useState } from 'react'
import { DashboardCard } from '../commons/dashboardCard'
import { getDashboardData } from '../utils/api'

function ControlQuiz() {
  const [dasboardData, setDashboardData] = useState({})

  useEffect(() => {
    try {
      fetchData()
    } catch (error) {
      console.log(error)
    }
  }, [])

  async function fetchData() {
    let apiResponse = await getDashboardData({})
    let temp = { ...apiResponse.data }
    setDashboardData(temp)
  }

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row" style={{ justifyContent: 'space-evenly' }}>
          <DashboardCard label="Users" value={dasboardData.user} image="https://picsum.photos/100/100"></DashboardCard>
          <DashboardCard label="Activities" value={dasboardData.activity} image="https://picsum.photos/100/100"></DashboardCard>
          <DashboardCard label="Matches" value={dasboardData.match} image="https://picsum.photos/100/100"></DashboardCard>
          <DashboardCard label="Interests" value={dasboardData.interest} image="https://picsum.photos/100/100"></DashboardCard>
          <DashboardCard label="Transactions" value={dasboardData.order} image="https://picsum.photos/100/100"></DashboardCard>
        </div>
      </div>
    </div>
  )
}

export { ControlQuiz }
